function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "prefix__a",
  width: "160.7%",
  height: "160.7%",
  x: "-30.4%",
  y: "-23.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 4,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
})), /*#__PURE__*/React.createElement("circle", {
  id: "prefix__b",
  cx: 28,
  cy: 28,
  r: 28
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M0 0H360V1165H0z",
  transform: "translate(-300 -1053)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M20 322h320c11.046 0 20 8.954 20 20v831H0V342c0-11.046 8.954-20 20-20z",
  transform: "translate(-300 -1053)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-300 -1053) translate(284 1037)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#prefix__a)",
  xlinkHref: "#prefix__b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#prefix__b"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#222",
  transform: "translate(16 16)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 19.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 5.5,
  r: 1.5
}))));

function SvgMoreVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/more-vertical.95849e64.svg";
export { ForwardRef as ReactComponent };